"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8726],{

/***/ 48726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ OurStory_PageContents; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/Elements/index.js + 6 modules
var Elements = __webpack_require__(41551);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(52261);
;// CONCATENATED MODULE: ./containers/OurStory/PageContents/Contents/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 22px;\n  @media only screen and (max-width: 560px) {\n    padding-top: 16px;\n    padding-left: 8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 22px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ';\n  font-family: "OpenSans SemiBold";\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  span.highlight {\n    color: ",
        ";\n    font-size: 22px;\n  }\n  span.highlight-black {\n    font-weight: bold;\n  }\n\n  @media only screen and (max-width: 560px) {\n    font-size: 15px;\n    span.highlight {\n      font-size: 15px;\n    }\n    span.highlight-black {\n      font-weight: bold;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c37a70a-0"
})(_templateObject());
var ContentWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c37a70a-1"
})(_templateObject1());
var SubTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c37a70a-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.textStyles.content2;
}, function(param) {
    var theme = param.theme;
    return theme.colors.prune;
});
var CustomTextM = (0,styled_components_browser_esm/* default */.ZP)(Elements/* TextM */.Ei).withConfig({
    componentId: "sc-3c37a70a-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.prune;
});

;// CONCATENATED MODULE: ./containers/OurStory/_page.js
var template = {
    pageTitle: "Our Story",
    contents: {
        dynamicContents: [
            {
                id: 1,
                title: "How it all began",
                subContents: "<strong>our idea of the perfect closet solution</strong>"
            },
            {
                id: 2,
                title: "",
                subContents: "Roger Washburn started out working as an Installer for corporate Classy Closets in Arizona.  After a few years he became a partner with the local franchisees in Salt Lake City, and after a few more years he and his wife Patty bought his partners out to become sole owner of the Utah Classy Closet Franchise (except St. George).  "
            },
            {
                id: 3,
                title: "",
                subContents: "Roger knows and understands the business better than most in the industry. Because of his experience in the industry, the talented professional designers & installation team he has assembled, and the fact that Classy Closets Utah manufactures and finishes all of their own products, they are able to provide customized solutions better than anyone else!"
            }, 
        ]
    }
};

;// CONCATENATED MODULE: ./containers/OurStory/PageContents/Contents/index.js





var Contents = function() {
    var contents = template.contents;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: contents.dynamicContents.map(function(content, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ContentWrap, {
                children: [
                    (content === null || content === void 0 ? void 0 : content.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* TitleM */.ek, {
                        talign: "left",
                        children: content.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextM, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: content.subContents
                            }
                        })
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var PageContents_Contents = (Contents);

// EXTERNAL MODULE: ../../node_modules/antd/es/row/index.js
var row = __webpack_require__(3306);
// EXTERNAL MODULE: ../../node_modules/antd/es/col/index.js
var col = __webpack_require__(3086);
// EXTERNAL MODULE: ./components/Cards/index.js + 8 modules
var Cards = __webpack_require__(642);
;// CONCATENATED MODULE: ./containers/OurStory/PageContents/CardSection/styled.js

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 0;\n\n  @media only screen and (max-width: 560px) {\n    margin-bottom: 26px;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-472a7c9e-0"
})(styled_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacings.spacing_xl;
});
var CustomCard = (0,styled_components_browser_esm/* default */.ZP)(Cards/* ServiceCard */.WF).withConfig({
    componentId: "sc-472a7c9e-1"
})(styled_templateObject1());

;// CONCATENATED MODULE: ./containers/OurStory/PageContents/CardSection/_cards.js
var cards = [
    {
        id: 1,
        type: "service",
        title: "OUR PRODUCTS",
        imgSrc: "/images/why_choose_classy_closets/our-products.png",
        contentTitle: "",
        content: "",
        btnText: "View All",
        href: "view-all-products"
    },
    // {
    //   id: 2,
    //   type: "blog",
    //   title: "ON THE BLOG",
    //   imgSrc: "/images/home_page/custom_homeoffice.jpg",
    //   contentTitle: "",
    //   content: "",
    //   btnText: "View Blog",
    //   href: "/blog"
    // },
    {
        id: 3,
        type: "service",
        title: "CLOSETS",
        imgSrc: "/images/home_page/closets.jpg",
        contentTitle: "",
        content: "",
        btnText: "Closets",
        href: "/products/closets"
    }, 
];

;// CONCATENATED MODULE: ./containers/OurStory/PageContents/CardSection/index.js





var CardSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
            gutter: {
                xs: 16,
                sm: 20,
                md: 20,
                lg: 20
            },
            children: cards.map(function(card, key) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    xs: 24,
                    sm: 12,
                    md: 12,
                    lg: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCard, {
                        type: card.type,
                        title: card.title,
                        imgSrc: card.imgSrc,
                        content: card.content,
                        contentTitle: card.contentTitle,
                        btnText: card.btnText,
                        bptop: "20px",
                        url: card.href
                    })
                }, key);
            })
        })
    });
};
/* harmony default export */ var PageContents_CardSection = (CardSection);

;// CONCATENATED MODULE: ./containers/OurStory/PageContents/styled.js

function PageContents_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 35px;\n  padding-bottom: 60px;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n\n  @media only screen and (max-width: 768px) {\n    padding-left: ",
        "px;\n    padding-right: ",
        "px;\n  }\n  @media only screen and (max-width: 560px) {\n    padding-top: 16px;\n    padding-bottom: 41px;\n    padding-left: ",
        "px;\n    padding-right: ",
        "px;\n  }\n"
    ]);
    PageContents_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PageContents_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9181b3e4-0"
})(PageContents_styled_templateObject(), function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.ipad;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.ipad;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.mobile;
});

;// CONCATENATED MODULE: ./containers/OurStory/PageContents/index.js






var PageContents = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageContents_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* TitleL */.lr, {
                talign: "left",
                children: "Our Story"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContents_Contents, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContents_CardSection, {})
        ]
    });
};
/* harmony default export */ var OurStory_PageContents = (PageContents);


/***/ })

}]);